import AutoCountModel from 'logic/models/AutoCountModel'
import AutoLimitModel from 'logic/models/AutoLimitModel'
import BalanceModel from 'logic/models/BalanceModel'
import BetModel from 'logic/models/BetModel'
import BonusMultiplierModel from 'logic/models/BonusMultiplierModel'
import FreespinModel from 'logic/models/FreespinModel'
import GambleModel from 'logic/models/GambleModel'
import GameModel from 'logic/models/GameModel'
import ItemsModel from 'logic/models/ItemsModel'
import ModeModel from 'logic/models/ModeModel'
import PayoutModel from 'logic/models/PayoutModel'
import ResponseDataModel from 'logic/models/ResponseDataModel'
import SizeModel from 'logic/models/SizeModel'
import SpinModel from 'logic/models/SpinModel'
import UserModel from 'logic/models/UserModel'
import WinModel from 'logic/models/WinModel'

import CascadeModel from './models/CascadeModel'
import FreebetsModel from './models/FreebetsModel'
import JurisdictionModel from './models/JurisdictionModel'
import PaytableModel from './models/PaytableModel'

export default class Models {
  constructor() {
    this.ResponseDataModel = new ResponseDataModel()
    this.ItemsModel = new ItemsModel()
    this.AutoCountModel = new AutoCountModel()
    this.AutoLimitModel = new AutoLimitModel()
    this.BalanceModel = new BalanceModel()
    this.GambleModel = new GambleModel()
    this.BetModel = new BetModel()
    this.WinModel = new WinModel()
    this.BonusMultiplierModel = new BonusMultiplierModel()
    this.FreespinModel = new FreespinModel()
    this.FreebetsModel = new FreebetsModel()
    this.GameModel = new GameModel()
    this.ModeModel = new ModeModel()
    this.PayoutModel = new PayoutModel()
    this.SpinModel = new SpinModel()
    this.UserModel = new UserModel()
    this.SizeModel = new SizeModel()
    this.PaytableModel = new PaytableModel()
    this.CascadeModel = new CascadeModel()
    this.JurisdictionModel = new JurisdictionModel()
  }
}
